<template>
  <div id="csContainer">
    <div id="controls">
      <el-button type="primary" size="small" id="foolr">复位</el-button>
      <el-button type="primary" size="small" id="foolr5">5楼剖面查看</el-button>
      <el-button type="primary" size="small" id="foolr4">4楼剖面查看</el-button>
      <el-button type="primary" size="small" id="foolr3">3楼剖面查看</el-button>
      <el-button type="primary" size="small" id="foolr2">2楼剖面查看</el-button>
      <el-button type="primary" size="small" id="foolr1">1楼剖面查看</el-button>
    </div>
  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                let viewer = util.getViewer("csContainer",{
                    // imageryProvider: new Cesium.UrlTemplateImageryProvider({
                    //     url : 'http://www.google.cn/maps/vt?lyrs=s@716&x={x}&y={y}&z={z}'
                    // })
                });
                let scene = viewer.scene;
                viewer.scene.globe.depthTestAgainstTerrain = true;
                viewer.resolutionScale = window.devicePixelRatio;
                viewer.scene.fxaa = true;
                viewer.scene.postProcessStages.fxaa.enabled = true;


              // 添加剪裁
              //   var clippingPlanes1 = new Cesium.ClippingPlaneCollection({
              //     modelMatrix: tileset.modelMatrix,
              //     planes: [
              //       new Cesium.ClippingPlane(new Cesium.Cartesian3(0, 0, -1),0)
              //     ],
              //     edgeColor: Cesium.Color.WHITE,
              //     edgeWidth: 0,
              //     enabled: true
              //   });
                var targetY = -30;
                function createPlaneUpdateFunction(plane) {
                  return function() {
                    plane.distance = targetY + 10;
                    return plane;
                  };
                }
              let tileset = new Cesium.Cesium3DTileset({
                url:  "/demo/static/data/models/lanhai/tileset.json",
                maximumScreenSpaceError: 0.1,
                maximumMemoryUsage: 2048,
                // debugShowBoundingVolume: true
                // clippingPlanes: clippingPlanes
              });
                // var tileset = scene.primitives.add(
                //         new Cesium.Cesium3DTileset({
                //           url: '/demo/static/data/models/lanhai/tileset.json',
                //           debugShowBoundingVolume: false,
                //           clippingPlanes: clippingPlanes
                //         })
                // );
              tileset.readyPromise.then((tileset) => {
                tileset.maximumScreenSpaceError = 0.1
                tileset.maximumMemoryUsage = 2048
                let m = Cesium.Matrix4.fromArray([
                  1, 0.0, 0.0, 0.0,
                  0.0, 1, 0.0, 0.0,
                  0.0, 0.0, 1, 0.0,
                  30, 40, 0, 1.0
                ]);

                let longitude = 116.298782
                let latitude = 40.047983
                let height = 35
                let scale = Cesium.Matrix4.fromUniformScale(0.01);
                let hpr = new Cesium.Matrix3();

                var heading=Cesium.Math.toRadians(-115);

                // heading围绕负z轴的旋转。pitch是围绕负y轴的旋转。Roll是围绕正x轴的旋转
                let hprObj = new Cesium.HeadingPitchRoll(heading, Math.PI, Math.PI)
                hpr = Cesium.Matrix3.fromHeadingPitchRoll(hprObj, hpr)


                let modelMatrix = Cesium.Matrix4.multiplyByTranslation(
                        Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(longitude, latitude, height)), new Cesium.Cartesian3(), new Cesium.Matrix4()
                );

                modelMatrix = Cesium.Matrix4.multiplyByMatrix3(modelMatrix, hpr, modelMatrix);
                modelMatrix =  Cesium.Matrix4.multiply(modelMatrix, m, m);

                let ab = tileset._root.transform;

                tileset._root.transform = Cesium.Matrix4.multiply(modelMatrix, scale, modelMatrix);

                let ab12 = tileset._root.transform;
                console.log(ab);
                console.log(ab12)
;
                viewer.scene.primitives.add(tileset);


                viewer.flyTo(tileset, { offset: new Cesium.HeadingPitchRange(0.5, -0.2, tileset.boundingSphere.radius) })

                // 添加剪裁
                var boundingSphere = tileset.boundingSphere; // 模型的包围球范围
                var radius = boundingSphere.radius; // 长度

                console.log(boundingSphere)

                var clippingPlanes = new Cesium.ClippingPlaneCollection({
                  modelMatrix: tileset.modelMatrix,
                  planes: [
                    new Cesium.ClippingPlane(new Cesium.Cartesian3(0, 0, -1),0)
                  ],
                  edgeColor: Cesium.Color.WHITE,
                  edgeWidth: 0,
                  enabled: true
                });

                tileset.clippingPlanes = clippingPlanes;

                // clippingPlanes.modelMatrix = Cesium.Matrix4.multiply(clippingPlanes.modelMatrix, tileset._root.transform, clippingPlanes.modelMatrix);

                // viewer.zoomTo(tileset, new Cesium.HeadingPitchRange(0.5, -0.2, radius * 4.0));
                for (var i = 0; i < clippingPlanes.length; ++i) {
                  var plane = clippingPlanes.get(i);
                  viewer.entities.add({
                    position: boundingSphere.center,
                    plane: {
                      dimensions: new Cesium.Cartesian2(radius , radius ),
                      material: Cesium.Color.WHITE.withAlpha(0),
                      plane: new Cesium.CallbackProperty(createPlaneUpdateFunction(plane), false),
                      outline: false,
                      // outlineColor: Cesium.Color.WHITE
                    }
                  });

                }

              })
              document.getElementById('foolr5').onclick = () => {
                targetY = -1600;
              }

              document.getElementById('foolr4').onclick = () => {
                targetY = -2000;
              }
              document.getElementById('foolr3').onclick = () => {
                targetY = -2400;
              }
              document.getElementById('foolr2').onclick = () => {
                targetY = -2800;
              }
              document.getElementById('foolr1').onclick = () => {
                targetY = -3200;
              }
              document.getElementById('foolr').onclick = () =>{
                targetY = -1000;
              }

            },
        },

    }
</script>
<style scoped>
  .headMap {
    position: absolute;
    margin-left: 25px;
    margin-top:7px;
    z-index: 999;
  }
  #heatmap{
    width: 500px;
    height: 500px;
  }
  #controls {
    position: absolute;
    left: 1%;
    top: 1%;
    z-index: 10000;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
